import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";

// import SAME dropdown options used in RegisterCard
import {
  GENDER_OPTIONS,
  MOTHER_TONGUE_OPTIONS,
  MARITAL_STATUS_OPTIONS,
  CHILDREN_OPTIONS,
  KIDS_LIVE_WITH_OPTIONS,
  RELIGION_OPTIONS,
  CASTE_OPTIONS,
  ZODIAC_OPTIONS,
  STAR_OPTIONS,
  BODY_TYPE_OPTIONS,
  PHYSICAL_STATUS_OPTIONS,
  HEIGHT_OPTIONS,
  WEIGHT_OPTIONS,
  COMPLEXION_OPTIONS,
  COUNTRY_OPTIONS,
  RESIDENT_STATUS_OPTIONS,
  SEVVAI_LAKNA_OPTIONS,
  PROFILE_CREATED_BY_OPTIONS,
  STAR_PATHAM_OPTIONS,
  EATING_HABIT_OPTIONS,
  DRINKING_HABIT_OPTIONS,
  SMOKING_HABIT_OPTIONS,
} from "../../../utils/selectOptions.js";

const EditProfileDialog = ({ open, onClose, editData, setEditData, onSave }) => {
  const handleChange = (field, value) => {
    setEditData({ ...editData, [field]: value });
  };

  // ---------------- Reusable Input ----------------
  const Input = ({ label, field, type = "text" }) => (
    <div className='input-group'>
      <label>{label}</label>
      <input type={type} value={editData?.[field] || ""} onChange={(e) => handleChange(field, e.target.value)} />
    </div>
  );

  // ---------------- Reusable Select ----------------
  const Select = ({ label, field, options, placeholder = "Select" }) => (
    <div className='input-group'>
      <label>{label}</label>
      <select value={editData?.[field] || ""} onChange={(e) => handleChange(field, e.target.value)}>
        <option value=''>{placeholder}</option>
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );

  return (
    <Dialog open={open} onClose={onClose} maxWidth='lg' fullWidth>
      <DialogTitle>
        <h3>Edit Full Profile</h3>
      </DialogTitle>

      <DialogContent>
        <div className='premium-form'>
          {/* ================= BASIC ================= */}
          <h3 className='section-title'>Basic Information</h3>
          <div className='form-grid'>
            <Input label='Full Name' field='fullName' />
            <Input label='Mobile' field='mobile' />
            <Input label='Date of Birth' field='dob' type='date' />
            <Input label='Birth Time' field='birth_time' type='time' />

            <Select label='Gender' field='gender' options={GENDER_OPTIONS} />
          </div>

          {/* ================= PERSONAL ================= */}
          <h3 className='section-title'>Personal Details</h3>
          <div className='form-grid'>
            <Select label='Mother Tongue' field='mother_tongue' options={MOTHER_TONGUE_OPTIONS} />
            <Select label='Profile Created By' field='profile_created_by' options={PROFILE_CREATED_BY_OPTIONS} />

            <Select label='Marital Status' field='marital_status' options={MARITAL_STATUS_OPTIONS} />
            <Select label='Children' field='children' options={CHILDREN_OPTIONS} />
            <Select label='Kids Live With' field='kids_live_with' options={KIDS_LIVE_WITH_OPTIONS} />

            <Select label='Religion' field='religion' options={RELIGION_OPTIONS} />
            <Select label='Caste' field='caste' options={CASTE_OPTIONS} />

            <Select label='Zodiac' field='zodiac' options={ZODIAC_OPTIONS} />
            <Select label='Star' field='star' options={STAR_OPTIONS} />
            <Select label='Star Patham' field='star_patham' options={STAR_PATHAM_OPTIONS} />
          </div>

          {/* ================= PHYSICAL ================= */}
          <h3 className='section-title'>Physical Information</h3>
          <div className='form-grid'>
            <Select label='Body Type' field='body_type' options={BODY_TYPE_OPTIONS} />
            <Select label='Physical Status' field='physical_status' options={PHYSICAL_STATUS_OPTIONS} />

            <Select label='Height' field='height' options={HEIGHT_OPTIONS} />
            <Select label='Weight' field='weight' options={WEIGHT_OPTIONS} />

            <Select label='Complexion' field='complexion' options={COMPLEXION_OPTIONS} />
          </div>

          {/* ================= LOCATION ================= */}
          <h3 className='section-title'>Location</h3>
          <div className='form-grid'>
            <Select label='Birth Country' field='birth_country' options={COUNTRY_OPTIONS} />
            <Select label='Resident Country' field='resident_country' options={COUNTRY_OPTIONS} />
            <Select label='Resident Status' field='resident_status' options={RESIDENT_STATUS_OPTIONS} />

            <Input label='City' field='city' />
            <Input label='Address' field='address' />
          </div>

          {/* ================= CAREER ================= */}
          <h3 className='section-title'>Career</h3>
          <div className='form-grid'>
            <Input label='Education' field='education' />
            <Input label='Occupation' field='occupation' />
          </div>

          {/* ================= FAMILY ================= */}
          <h3 className='section-title'>Family Details</h3>
          <div className='form-grid'>
            <Input label='Father Place' field='father_place' />
            <Input label='Mother Place' field='mother_place' />

            <Select label='Father Caste' field='father_caste' options={CASTE_OPTIONS} />
            <Select label='Mother Caste' field='mother_caste' options={CASTE_OPTIONS} />

            <Input label='Father Occupation' field='father_occupation' />
            <Input label='Mother Occupation' field='mother_occupation' />
          </div>

          {/* ================= LIFESTYLE ================= */}
          <h3 className='section-title'>Lifestyle</h3>
          <div className='form-grid'>
            <Input label='Hobbies' field='hobbies' />
            <Select label='Eating Habit' field='eating_habit' options={EATING_HABIT_OPTIONS} />
            <Select label='Drinking Habit' field='drinking_habit' options={DRINKING_HABIT_OPTIONS} />
            <Select label='Smoking Habit' field='smoking_habit' options={SMOKING_HABIT_OPTIONS} />
          </div>

          {/* ================= ASTROLOGY ================= */}
          <h3 className='section-title'>Astrology</h3>
          <div className='form-grid'>
            <Input label='Kiraga Paavam' field='kiraga_paavam' />
            <Select label='Sevvai Lakna' field='sevvai_lakna' options={SEVVAI_LAKNA_OPTIONS} />
          </div>

          {/* ================= ABOUT ================= */}
          <h3 className='section-title'>About</h3>

          <div className='input-group full-width'>
            <label>About Me</label>
            <textarea rows={4} value={editData?.about || ""} onChange={(e) => handleChange("about", e.target.value)} />
          </div>

          <div className='input-group full-width'>
            <label>Partner Preferences</label>
            <textarea
              rows={4}
              value={editData?.partner_qualities || ""}
              onChange={(e) => handleChange("partner_qualities", e.target.value)}
            />
          </div>
          {editData?.photo && (
            <img
              src={editData.photo}
              alt='Profile'
              style={{
                width: 120,
                height: 120,
                objectFit: "cover",
                borderRadius: 12,
                marginBottom: 10,
              }}
            />
          )}

          <div className='input-group'>
            <label>Profile Photo</label>
            <input
              type='file'
              accept='.jpg,.jpeg,.png'
              onChange={(e) =>
                setEditData({
                  ...editData,
                  photo: e.target.files?.[0] || null,
                })
              }
            />
          </div>
          {editData?.horoscope && (
            <img
              src={editData.horoscope}
              alt='Horoscope'
              style={{
                width: 120,
                borderRadius: 12,
                marginBottom: 10,
              }}
            />
          )}
          <div className='input-group'>
            <label>Horoscope</label>
            <input
              type='file'
              accept='.jpg,.jpeg,.png'
              onChange={(e) =>
                setEditData({
                  ...editData,
                  horoscope: e.target.files?.[0] || null,
                })
              }
            />
          </div>
        </div>
      </DialogContent>

      <DialogActions>
        <button className='btn-outline' onClick={onClose}>
          Cancel
        </button>

        <button className='btn-primary' onClick={onSave}>
          Save Changes
        </button>
      </DialogActions>
    </Dialog>
  );
};

export default EditProfileDialog;
